import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../rtkQuery';
import { restApiFormData } from '../axios';
import { API_ENDPOINTS } from '../constants';

export const changeRequestsAPI = createApi({
    reducerPath: 'changeRequestsAPI',
    baseQuery: axiosBaseQuery(restApiFormData),
    endpoints: (builder) => ({
        getChangeRequests: builder.mutation({
            query: ({ query, body }) => ({
                url: `${API_ENDPOINTS.LIST_CHANGE_REQUESTS}?${query.toString()}`,
                method: 'POST',
                data: body,
            }),
        }),
        searchChangeRequests: builder.mutation({
            query: ({ query, body }) => ({
                url: `${API_ENDPOINTS.SEARCH_CHANGE_REQUESTS_ACTION}?${query.toString()}`,
                method: 'POST',
                data: body,
            }),
        }),
        bulkUpdateChangeRequestStatuses: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.BULK_UPDATE_CHANGE_REQUEST_STATUSES,
                method: 'POST',
                data: data,
            }),
        }),
        changeChangeRequestStatus: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.ACTION_CHANGE_REQUEST,
                method: 'POST',
                data: data,
            }),
        }),
        cancelChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CANCEL_ACTIVE_CHANGE_REQUEST,
                method: 'POST',
                data: data,
            }),
        }),
        deleteChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DELETE_CHANGE_REQUEST,
                method: 'POST',
                data,
            }),
        }),
        preCreateChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.PRE_CREATE_CHANGE_REQUEST,
                method: 'POST',
                data,
            }),
        }),
        preCreateChangeRequestWithCompaFields: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.PRE_CREATE_CHANGE_REQUEST_WITH_COMPA_FIELDS,
                method: 'POST',
                data,
            }),
        }),
        preCreateBulkChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.PRE_CREATE_BULK_CHANGE_REQUEST,
                method: 'POST',
                data,
            }),
        }),
        preCreateBulkChangeRequestWithCompaFields: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.PRE_CREATE_BULK_CHANGE_REQUEST_WITH_COMPA_FIELDS,
                method: 'POST',
                data,
            }),
        }),
        createChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CREATE_CHANGE_REQUEST,
                method: 'POST',
                data,
            }),
        }),
        createChangeRequestWithCompaFields: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CREATE_CHANGE_REQUEST_WITH_COMPA_FIELDS,
                method: 'POST',
                data,
            }),
        }),
        createBulkChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CREATE_BULK_CHANGE_REQUEST,
                method: 'POST',
                data,
            }),
        }),
        createBulkChangeRequestWithCompaFields: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.CREATE_BULK_CHANGE_REQUEST_WITH_COMPA_FIELDS,
                method: 'POST',
                data,
            }),
        }),
        preModifyChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.PRE_MODIFY_CHANGE_REQUEST,
                method: 'POST',
                data,
            }),
        }),
        preModifyChangeRequestWithCompaFields: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.PRE_MODIFY_CHANGE_REQUEST_WITH_COMPA_FIELDS,
                method: 'POST',
                data,
            }),
        }),
        modifyChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_CHANGE_REQUEST,
                method: 'POST',
                data,
            }),
        }),
        modifyChangeRequestWithCompaFields: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.MODIFY_CHANGE_REQUEST_WITH_COMPA_FIELDS,
                method: 'POST',
                data,
            }),
        }),
        displayChangeRequest: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DISPLAY_CHANGE_REQUEST,
                method: 'POST',
                data,
            }),
        }),
        displayChangeRequestWithCompaFields: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.DISPLAY_CHANGE_REQUEST_WITH_COMPA_FIELDS,
                method: 'POST',
                data,
            }),
        }),

        // Change Request Policy Roles endpoints
        preCreateRolesMappingToChangeRequestPolicy: builder.mutation({
            query: () => ({
                url: API_ENDPOINTS.PRE_CREATE_ROLES_MAPPING_TO_CHANGE_REQUEST_POLICY,
                method: 'POST',
            }),
        }),
        saveRolesMappedToChangeRequestPolicy: builder.mutation({
            query: (data) => ({
                url: API_ENDPOINTS.SAVE_ROLES_MAPPED_TO_CHANGE_REQUEST_POLICY,
                method: 'POST',
                data,
            }),
        }),
    }),
});

export const {
    useGetChangeRequestsMutation,
    useSearchChangeRequestsMutation,
    useBulkUpdateChangeRequestStatusesMutation,
    useChangeChangeRequestStatusMutation,
    useCancelChangeRequestMutation,
    useDeleteChangeRequestMutation,
    usePreCreateChangeRequestMutation,
    usePreCreateChangeRequestWithCompaFieldsMutation,
    usePreCreateBulkChangeRequestMutation,
    usePreCreateBulkChangeRequestWithCompaFieldsMutation,
    useCreateChangeRequestMutation,
    useCreateChangeRequestWithCompaFieldsMutation,
    useCreateBulkChangeRequestMutation,
    useCreateBulkChangeRequestWithCompaFieldsMutation,
    usePreModifyChangeRequestMutation,
    usePreModifyChangeRequestWithCompaFieldsMutation,
    useModifyChangeRequestMutation,
    useModifyChangeRequestWithCompaFieldsMutation,
    useDisplayChangeRequestMutation,
    useDisplayChangeRequestWithCompaFieldsMutation,
    usePreCreateRolesMappingToChangeRequestPolicyMutation,
    useSaveRolesMappedToChangeRequestPolicyMutation,
} = changeRequestsAPI;
